import React, { Fragment } from 'react';
import { Editor } from 'draft-js';
import { Button, Space } from 'antd';
import { FeatureFlag } from '../../../featureFlags';
import { flags } from '../../../featureFlags/flags';
import BlockStyleControls from './BlockStyleControls';
import InlineStyleControls from './InlineStyleControls';

const EditorSimple = ( { editorState, toggleBlockType, toggleInlineStyle, setEditorState, placeholder, id,
    handleCopyClickCallback, handlePasteClickCallback } ) => {
    return (
        <Fragment>
            <div className="rte-controlbar">
                <BlockStyleControls
                    editorState={ editorState }
                    onToggle={ toggleBlockType }
                />
                <InlineStyleControls
                    editorState={ editorState }
                    onToggle={ toggleInlineStyle }
                />

                <FeatureFlag name={ flags.COPYPASTEHTML }>
                    <div className="rte-control-group" style={ { paddingTop: '6px', marginLeft: '10px' } }>
                        <Space>
                            <Button 
                                size="small"
                                type="dashed"
                                id="copy-html-button"
                                onClick={ () => handleCopyClickCallback() }
                            >
                                Copy HTML
                            </Button>
                            <Button 
                                size="small"
                                type="dashed"
                                id="paste-html-button" 
                                onClick={ () => handlePasteClickCallback() }
                            >
                                Paste HTML
                            </Button>
                        </Space>
                    </div> 
                </FeatureFlag>
            </div>
            
            <div id={ id } className="rte-editor">
                <Editor 
                    editorState={ editorState }
                    onChange={ setEditorState }
                    placeholder={ placeholder }
                />
            </div>
        </Fragment>
    );
};

export default EditorSimple;